<template>
  <section :class="colorTheme" :id="id">
    <div class="d-flex header align-items-end justify-content-between">
      <div>{{title}}</div>
      <div v-if="linkTitle"><router-link v-on:click.native="viewAll" :to="{ name: linkName}">{{linkTitle}}<i class="icon icon-color-arrow-right"></i></router-link></div>
    </div>
    <slot></slot>
  </section>
</template>
<script>
  export default {
    name: 'title-block',
    props: { id: {required: false, default: ''}, title: null, linkTitle: null, linkName: null, colorTheme: null },
    data () {
      return {
      }
    },
    methods: {
      viewAll: function (event) {
        if (this.$parent) {
          this.$parent.$emit('view-all', this.id)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  section.primary-color .header {
    min-height: 38px;
    border-color: $primary-color;
    padding: 8px 10px 8px 10px;
    padding-bottom: 8px;
  }
  section {
    margin-top: 5px;
    margin-bottom: 20px;
    .header {
      min-height: 48px;
      padding: 10px 10px 10px 15px;
      border-left: 4px solid $secondary-color;
      border-bottom: 1px solid rgba($secondary-color, 0.5);
      font-family: 'Merriweather';
      font-style: italic;
      color: $primary-color;
      font-size: 14px;
      a {
        white-space: nowrap;
        font-size: 12px;
        text-decoration: underline;
        position: relative;
        margin-right: -5px;
        .icon {
          margin-left: 10px;
        }
      }
    }
    &:after{
      content: '';
      display: table;
      clear: both;
    }
  }
</style>



// WEBPACK FOOTER //
// TitleBlockComponent.vue?cbbaf744